import { FC, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { TranslationsProvider } from 'translations';
import { selectLocale, selectToken, selectCustomBrandName } from '../../redux/slices/userSlice';

const IntlProviderContainer: FC<IntlProviderProps> = (props: IntlProviderProps) => {
    const locale = useSelector(selectLocale);
    const token = useSelector(selectToken);
    const customBrandName = useSelector(selectCustomBrandName);

    return (
        <TranslationsProvider
            useUserLocale
            userLocale={locale}
            userToken={token}
            customBrandName={customBrandName}
            preloadContentTranslations
        >
            {props.children}
        </TranslationsProvider>
    );
};

interface IntlProviderProps {
    children: ReactNode;
}

export default IntlProviderContainer;
